import { DetailCard, Layout, ListTitle, MTools, Tabs } from '@/components';
import React, { Component, createRef } from 'react';
import styles from './index.less';
import { getActivityList, getTopicClass, getTopicList } from '@/services/api';
import { RouteComponentProps, withRouter } from 'dva/router';
import { ITopic } from '@/models/types/topic';
import { IDict } from '@/models/types/dict';
import { IActivity } from '@/models/types/activity';
import BetterScroll from '@better-scroll/core'
import PullUp from '@better-scroll/pull-up'
import loadingIcon from '@/assets/image/loading.gif';

BetterScroll.use(PullUp)

interface ITopicProps {

}
type IProps = ITopicProps & RouteComponentProps<{ index: string }>
interface ITopicState {
  typeIndex: number;
  topic: ITopic | null;
  categories: IDict[];
  category: string;
  current: number;
  size: number;
  total: number;
  topicId: number | null;
  list: IActivity[];
  hasMore: boolean;
}
class Topic extends Component<IProps, ITopicState> {
  indexRef: any
  bs: any
  constructor(props: IProps) {
    super(props)
    this.state = {
      typeIndex: +props.match.params.index,
      topic: null,
      categories: [],
      category: '',
      topicId: null,
      current: 1,
      size: 12,
      total: 0,
      hasMore: true,
      list: []
    }
    this.indexRef = createRef()
  }

  componentDidMount() {
    this.init()
    this.getData()
    this.getList()
    this.getCategories()
  }

  init = () => {
    this.bs = new BetterScroll(this.indexRef.current, {
      pullUpLoad: true,
      click: true,
      bounce: false
    })
    this.bs.on('pullingUp', () => {
      this.getData()
      this.bs.finishPullUp()
    })
  }

  getData = async () => {
    const { typeIndex } = this.state
    const result = await getTopicList()
    if (result.success) {
      if (result.data.length && result.data[typeIndex - 1]) {
        this.setState({
          topic: result.data[typeIndex - 1],
          topicId: result.data[typeIndex - 1].id
        }, this.getList)
      }
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  getList = async () => {
    const { current, size, category, topicId, list } = this.state
    if (!topicId) return
    const result = await getActivityList({
      current,
      size,
      query: {
        status: 1,
        topicId,
        dictValue: category || undefined
      }
    })
    if (result.success) {
      const { records, total } = result.data

      let hasMore = true
      if (+total <= (current - 1) * size + records.length) {
        hasMore = false
      }

      this.setState({
        list: [...list, ...records],
        total: total,
        current: current + 1,
        hasMore
      }, () => {
        this.bs.refresh()
      })
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  getCategories = async () => {
    if (this.state.typeIndex === 1) {
      const result = await getTopicClass();
      if (result.success) {
        this.setState({
          categories: result.data
        })
      } else {
        MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
      }
    }
  }

  onDictChange = (key: string) => {
    this.setState({
      current: 1,
      hasMore: true,
      category: key,
      list: []
    }, this.getData)
  }


  render() {
    const { list, topic, hasMore, current, typeIndex, categories } = this.state;
    return (
      <div className={styles.index} ref={this.indexRef}>
        <Layout
          breadcrumb={[{
            title: topic?.title || ''
          }]}
        >
          <ListTitle title={topic?.title || ''} />
          {typeIndex === 1 && <div className={styles.tab}>
            <Tabs data={categories} onDictChange={this.onDictChange}></Tabs>
          </div>}
          <div className={styles.list}>
            {list.map(item => {
              return (
                <div
                  className={styles.item}
                  key={item.id}
                  onClick={() => {
                    this.props.history.push(`/app/topic/detail/${item.id}?type=${typeIndex}&typeTitle=${topic?.title}`)
                  }}
                >
                  <DetailCard item={item as any}></DetailCard>
                </div>
              )
            })}
          </div>
          <div className={styles.bottom}>
            {hasMore && current !== 1 && <div className={styles.loadMore}>
              <img src={loadingIcon} alt="" />
              加载更多
            </div>}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withRouter(Topic);
